import React from "react";
import "./services.css";

const experienceData = [
  {
    company: "DCoding Labs",
    position: "Senior Full-Stack Engineer",
    period: "Feb 2024 - Present",
    current: true,
    summary:
      "Working on PlateSpect and DroSpect - platforms for vehicle monitoring and drone inspections. Building React/TS frontends, NestJS microservices, and deploying everything on GCP with Terraform.",
  },
  {
    company: "Visiar Healthcare",
    position: "Full-Stack Engineer",
    period: "Jan 2023 - Jan 2024",
    current: false,
    summary:
      "Built healthcare apps with React Native and Next.js. Worked in a Scrum team shipping features across multiple products and handling the full release cycle.",
  },
  {
    company: "Sponex",
    position: "Frontend Developer",
    period: "Nov 2020 - Dec 2022",
    current: false,
    summary:
      "Where it all started. Built frontends with React, Next.js, Three.js, and Tailwind. Focused on performance, responsive design, and shipping pixel-perfect UIs.",
  },
];

const Services = () => {
  return (
    <section id="experience" aria-labelledby="experience-heading">
      <h5>Where I&apos;ve worked</h5>
      <h2 id="experience-heading">Experience</h2>

      <div className="container services__timeline reveal">
        {experienceData.map((exp) => (
          <article
            key={exp.company}
            className={`timeline__item glass pixel-corners${
              exp.current ? " timeline__item--current" : ""
            }`}
          >
            <div className="timeline__header">
              <div>
                <h3>{exp.company}</h3>
                <span className="timeline__position">{exp.position}</span>
              </div>
              <span className="timeline__period">{exp.period}</span>
            </div>
            <p className="timeline__summary">{exp.summary}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Services;
